import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountSuperAdminLeadView implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSuperAdminLeadViewContainer";
    }
    render(){
        // console.log("SuperAdmin lead view");
    }
}